<template>
  <div>
    <Card
      :title="name"
    >
      <template v-slot:button>
        <Button  @clicked="goBack" variant="default" label="Cancel" />
        <Button @clicked="submit" variant="primary" label="Save" />
      </template>
      <template v-slot:body>
        <div class="flex flex-col border-b border-gray-200 py-3">
          <div class="flex justify-between">
            <h5 class="text-gray-700 text-sm py-2 font-bold uppercase">
              Video List
            </h5>
            <Button variant="outline-primary" label="Add Video" @clicked="isShowingModal = true" />
          </div>
          <text-error v-if="isVideosEmpty" text="Videos cannot be empty" />
        </div>
        <el-table-draggable  handle=".handle-move"  v-if="dataVideos.length > 0" >
          <el-table :data="dataVideos" row-key="id" :show-header="false" style="width: 100%">
            <el-table-column label="Handle" align="center" key="handle">
              <div class="static inline-block text-center container-action handle-move" style="cursor: move">
                <font-awesome-icon size="2x" :icon="['fa', 'th']" />
              </div>
            </el-table-column>
            <el-table-column v-for="column in tableColumn" :prop="column.prop" :label="column.label" :key="column.prop" sortable="custom">
            </el-table-column>
            <el-table-column  label="Thumbnail" align="left" width="150px" >
              <template slot-scope="scope">
                <img :src="scope.row.thumbnail" alt="" />
              </template>
            </el-table-column>
            <el-table-column label="Actions" align="right">
              <template slot-scope="scope">
                <div class="static inline-block text-left container-action">
                  <VueCustomTooltip label="Delete" :position="'is-left'">
                    <button @click="removeFromList(scope.row)" class="p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                    </button>
                  </VueCustomTooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-table-draggable>
        <div class="flex justify-center py-6 text-sm" v-if="dataVideos.length === 0">
          No videos added. Please add a videos to continue
        </div>
      </template>
    </Card>
    <ModalDialog
      size="xlarge"
      ref="addVideos"
      :isShowingModal="isShowingModal"
      title="Add Videos to Playlist"
      @toggleModal="isShowingModal = !isShowingModal"
      :labelSubmit="'Submit'"
      @save="submitAddVideos()" >
      <template slot="body" >
        <SearchVideos ref="addVideosContent" @on-remove-videos="onRemoveFromSearch" @on-submit-videos="addVideosPlaylist" :toggle-reset="isShowingModal"  :taken-videos="dataVideos" :section-id="sectionId"></SearchVideos>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';
import helpersMixin from '@/mixins/helpers.mixins';
import ModalDialog from '@/components/Common/ModalDialog';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import ElTableDraggable from 'el-table-draggable';
import SearchVideos from '@/views/MissionsVideos/VideoPage/VideoPageSearch.vue';
import Card from '@/components/Layout/Card.vue';
import { Button, FormItem, Input, Select, TextArea, TextError } from '@/components/Layout/Form';

const API_URL = process.env.API_URL;
export default {
  name: 'VideoPageDetail',
  mixins: [validationMixin, helpersMixin],
  data: () => ({
    sectionId: null,
    name: '',
    isShowingModal: false,
    isVideosEmpty: false,
    dataVideos: [],
    takenVideos: [],
    initialVideos: [],
    deletedVideos: [],
    tableColumn: [
      {
        prop: 'name',
        label: 'Video Name',
      },
      {
        prop: 'type',
        label: 'Type',
      },
      {
        prop: 'duration',
        label: 'Duration',
      },
    ],
  }),
  computed: {
    ...mapGetters('AuthModule', ['tokenType', 'accessToken']),
  },
  methods: {
    ...mapActions('VideoPageModule', ['requestDetailSection','requestAddContent']),
    ...mapActions('NotificationModule', ['setLoading', 'unsetLoading']),
    goBack(){
      this.$router.push({ name: 'VideoPageSection' })
    },
    async submit() {
      this.isVideosEmpty = this.checkVideosEmpty();
      const isValid = !this.isVideosEmpty;
      if (isValid) {
        const videoList = this.dataVideos.map(play => play.id);
        const playlist = {
          section_id: this.sectionId,
          videos: videoList,
          deleted_videos: this.deletedVideos,
        };
        await this.requestAddContent(playlist);
        this.$router.push({ name: 'VideoPageSection' });
      }
    },

    submitAddVideos() {
      this.$refs.addVideosContent.submit();
    },
    async addVideosPlaylist(data) {
      this.isShowingModal = false;
      if (data.length > 0) {
        this.setLoading();
        this.dataVideos = await Promise.all(data.map(async (video) => {
          return Object.assign(
            {},
            video,
          );
        }));
        this.unsetLoading();
      } else {
        this.dataVideos = [];
      }
      this.isVideosEmpty = this.checkVideosEmpty();
      this.isShowingModal = false;
    },
    removeFromList(row) {
      if (this.initialVideos.includes(row.id) && !this.deletedVideos.includes(row.id)) {
        this.deletedVideos.push(row.id);
      }
      const index = this.dataVideos.findIndex(song => song.id === row.id);
      this.dataVideos.splice(index, 1);
      this.isVideosEmpty = this.checkVideosEmpty();
    },
    onRemoveFromSearch(id) {
      if (this.initialVideos.includes(id) && !this.deletedVideos.includes(id)) {
        this.deletedVideos.push(id);
      }
    },
    checkVideosEmpty() {
      return this.dataVideos.length === 0;
    },
  },
  async mounted(){
    this.sectionId = Number(this.$route.params.sectionId);
    const detail = await this.requestDetailSection(this.sectionId);
    if (detail === null) {
      this.$router.push({ name: 'VideoPageSection' });
    }
    this.name = detail.section.name;
    if(detail.videos.length > 0){
      const _t = this;
      this.dataVideos = detail.videos.map(function(video){
        return {
          ...video,
          duration: _t.secToMinFormat(video.duration),
          type: video.type === 'podcast' ? 'Podcast': 'Mission',
        }
      })
    }
    this.initialVideos = [...detail.videos.map(s => s.id)];
  },
  components: { SearchVideos, ModalDialog, VueCustomTooltip, ElTableDraggable,Card,
    FormItem,
    Input,
    TextArea,
    Button,
    TextError,
    Select, },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/MissionsVideos/VideoPage/VideoPageDetail.vue